import { Directive, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DocumentService } from 'src/app/_services/document.service';
import { ProposalService } from 'src/app/_services/proposal.service';
import {
  Building,
  CoInsured,
  LegalProtectionMetadata,
} from 'src/app/_types/lead.types';
import { getSexEnumLabel } from 'src/app/enums/sex.enum';
import { getCountryName, LanguageCode } from 'src/app/helpers/nationalities';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class LegalProtectionMetadataComponentAbstract extends BaseMetadataComponent<LegalProtectionMetadata> {
  constructor(
    proposalService: ProposalService,
    private readonly documentService: DocumentService,
    private readonly cookieService: CookieService
  ) {
    super(proposalService);
  }

  getBooleanLabel = getBooleanLabel;

  inCoinsurersArray(
    element: CoInsured<string>,
    array: CoInsured<string>[] | undefined
  ) {
    return (
      !!array &&
      !!array.find(
        (x) =>
          x.birthDate === element.birthDate &&
          element.country === x.country &&
          element.firstName === x.firstName &&
          element.gender === x.gender &&
          element.lastName === x.lastName
      )
    );
  }

  inBuildingsArray(element: Building, array: Building[] | undefined) {
    return (
      !!array &&
      !!array.find(
        (x) =>
          x.address === element.address &&
          element.appartmentCount === x.appartmentCount &&
          element.postalCode === x.postalCode
      )
    );
  }

  languageCode =
    (this.cookieService.get('selectedCountryCode') as LanguageCode) || 'fr';

  getCountryName = getCountryName;

  getSexEnumLabel = getSexEnumLabel;

  displayAdditionalQuestions(metadata: LegalProtectionMetadata) {
    return (
      metadata &&
      (metadata?.risk ||
        metadata?.resiliation ||
        (metadata?.userInLitigation !== null &&
          metadata?.userInLitigation !== undefined) ||
        metadata?.company ||
        (metadata?.alreadyClient !== null &&
          metadata?.alreadyClient !== undefined))
    );
  }

  @ViewChild('pdfViewer') viewer!: PdfViewerModalComponent;

  viewFile(key: string) {
    this.documentService.getPresignedUrl(key).subscribe((res) => {
      if (res.status === 'SUCCESS') {
        this.viewer.pdfFileUrl = res.data.preSignedUrl;
        this.viewer.openModal();
      }
    });
  }
}
